import { useState } from "react";
import { faqs } from "@/mocks/comics";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于漫蛙漫画网的疑问"
          desc="围绕追更提醒、订阅费用与更新机制，我们整理了一些读者最常问的问题。"
        />

        <div className="divide-y divide-background-200 rounded-2xl bg-background-100 ring-1 ring-background-200">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                >
                  <h3 className="flex-1 font-heading text-base font-bold text-foreground-950">
                    {item.q}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-primary-600 transition-transform duration-300 ${
                      open ? "rotate-180 bg-primary-100" : "bg-background-200"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" aria-hidden="true" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}